import React, { useState, useEffect } from 'react';
import Header from '../Layout/Header';
import Table from './table';
import { MultiSelect } from 'react-multi-select-component';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getDepartmentMasterList } from '../../Component/Helpers/api';
import { CSVLink } from 'react-csv';
import moment from 'moment';
import mixpanel from 'mixpanel-browser';
import MarketingPanel from '../MarketingPanel';
import { getServiceAccess } from '../../Redux/action/userActions';
import Sidebar from "../Layout/Sidebar";
import CustomHeader from "../Layout/Header";
import { Layout } from "antd";
import Modal from 'react-bootstrap/Modal';


import {
  getDepartmentOptions,
  getDepartmentList,
  createDepartment,
  updateDepartment,
} from '../../Redux/action/departmentAction';
import { SeatListingDataBasedOnLocation } from '../../Redux/action/seatAction';
import { dataLocation } from '../Helpers/util'
import {
  dataUser,
  removeDuplicateObjectFromArray,
  arrayOfObjectIntersection,
} from '../Helpers/util';
import SwInput from '../Common/FormComponent/SwInput';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwMultiSelect from '../Common/SwMultiSelect/SwMultiSelect';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDTable from '../Common/AntDTable/AntDTable';
import SwModal from '../Common/SwModal/SwModal';
import SwLoader from '../Common/SwLoader/SwLoader';
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

const userDataLocal1 = dataLocation();
const LocationObj = JSON.parse(userDataLocal1);

function Department({
  departmentData: {
    spoc,
    seatArr,
    shiftStartTime,
    shiftEndTime,
    location,
    departmentList: { data: departmentList, loading: departmentListLoading, total: total },
  },
  seatList: { SeatList },
  getDepartmentOptions,
  createDepartment,
  getDepartmentList,
  updateDepartment,
  SeatListingDataBasedOnLocation,
}) {
  const [pgno, setPgno] = useState(1);
  const [row, setRow] = useState(25);
  const loader = true;

  const [departmentName, setDepartmentName] = useState('');
  const [showConfirmBooking, setShowConfirmBooking] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [location1, setLocation1] = useState([{ value: '', label: 'Select' }])
  const [selectedSpoc, setSelectedSpoc] = useState([]);
  const [selectedStartTime, setSelectedStartTime] = useState([]);
  const [selectedEndTime, setSelectedEndTime] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState({});
  const [seatsNumber, setSeatsNumber] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [csvData, setCSVData] = useState([]);
  const [items, setItems] = useState([]);
  const [searchText, setSearchText] = useState();
  const [accessServiceLists, setAccessServiceLists] = useState([]);
  const [loaderServiceAccess, setLoaderServiceAccess] = useState(true);
  const [delLocations, setDeletedLocation] = useState([]);

  const [showDeptCanvas, setShowDeptCanvas] = useState(false);





  useEffect(() => {
    btnClick();
  })

  useEffect(() => {
    getDepartmentOptions(UserObj.company_id);
    const param = {
      UserObj: UserObj.company_id,
      LocationObj: LocationObj,
      pgno: pgno,
      row: row,
    }
    getDepartmentList(param);
    isEditableUpdate();
    fetchServiceAccess();
  }, []);





  const handleCloseBooking = () => {
    setShowConfirmBooking(false)
  };
  const handleOpenBookingModal = () => {
    setShowConfirmBooking(true);
  }






  const toggleCollapsed = () => {
    setCollapsed((prevState) => !prevState);
  };

  // useEffect(() => {

  //   let authToken = JSON.parse(localStorage.getItem('headData'))

  //   const params = {
  //     params: { spoc: UserObj.rec_id, client: UserObj.company_id },
  //     headers: {
  //       Authorization: authToken?.spintlyToken,
  //     }
  //   };
  //   // const authTok = {
  //   //   headers: {
  //   //     Authorization: '763B744878E1736938EB78CB92179',
  //   //   },
  //   // };
  //   axios
  //     .get(
  //       `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
  //       params,
  //     )
  //     .then(res => {
  //       if (res.data.status == 'success') {
  //         setLocation1(res.data.data);
  //       }
  //     });
  // }, []);
  useEffect(() => {
    let authToken = JSON.parse(localStorage.getItem('headData'));

    if (UserObj.rec_id && UserObj.company_id) {
      const params = {
        params: { spoc: UserObj.rec_id, client: UserObj.company_id },
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      };

      axios
        .get(
          `${process.env.REACT_APP_API_URL}basic-data/get-location-by-spoc`,
          params,
        )
        .then(res => {
          if (res.data.status === 'success') {
            setLocation1(res.data.data);
          }
        })
        .catch(error => {
          console.error(error);
          // Handle errors here
        });
    }
  }, []);


  const LocationData = [];

  location1.map(item => LocationData.push({ value: item?.rec_id, label: item.location_name }));

  const fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    setAccessServiceLists(response);
    setLoaderServiceAccess(false);
  }

  const isEditableUpdate = () => {
    if (UserObj && UserObj.role_data && UserObj.role_data.length > 0) {
      const departmentMaster = UserObj.role_data.filter(
        element => element.service_id == '14',
      );
      if (
        departmentMaster[0].role_for_write &&
        departmentMaster[0].role_for_write === '1'
      ) {
        setIsEditable(true);
      }
    }
  };

  function exoprtDataGet(deptList) {
    var csvData = JSON.parse(JSON.stringify(deptList));
    var i = 0;
    deptList.forEach(dept => {
      var locationArray = [];
      var spocArray = [];
      var shiftStartTime = [];
      var shiftEndTime = [];
      var seatArray = [];
      var csvDate = moment(dept.createdat).format('DD-MM-YYYY');
      dept.locationArr.forEach(location => {
        locationArray.push(location.location_name);
      });
      dept.userArr.forEach(user => {
        var name = user.fname + user.lname;
        spocArray.push(name);
      });
      dept.shiftArr.forEach(time => {
        if (time.shift_type === 'start_time') {
          shiftStartTime.push(time.time);
        } else if (time.shift_type === 'end_time') {
          shiftEndTime.push(time.time);
        }
      });
      dept.seatArr.forEach(seat => {
        seatArray.push(seat.title);
      });
      csvData[i].locationArr = locationArray;
      csvData[i].userArr = spocArray;
      csvData[i].seatArr = seatArray;
      csvData[i].shiftStartTime = shiftStartTime;
      csvData[i].shiftEndTime = shiftEndTime;
      csvData[i].createdat = csvDate;

      i = i + 1;
    });
    setCSVData(csvData);
  }

  useEffect(() => {
    if (departmentList.length > 0) {
      const statingElement = pgno == 1 ? 0 : row * (pgno - 1);
      const nextElement =
        statingElement + row < departmentList.length
          ? statingElement + row
          : departmentList.length;
      exoprtDataGet(departmentList);
      setTableData(departmentList.slice(statingElement, nextElement));
      setItems(departmentList.slice(statingElement, nextElement));
      var updatedList = departmentList;
      let value = searchText;
      updatedList = updatedList.filter(function (item) {
        var locationArray = item.locationArr;
        var spocNameArray = item.userArr;
        if (
          item.dept_name.search(value) != -1 ||
          isLocationFound(locationArray, value) != undefined ||
          isSpocsName(spocNameArray, value) != undefined
        ) {
          return item;
        }
      });
      setItems(updatedList);
    }
  }, [departmentList, pgno, row]);
  const spocOptions = spoc.map(el => ({
    value: el.rec_id,
    label: `${el.fname} ${el.lname}`,
  }));
  const shiftStartOptions = shiftStartTime.map(el => ({
    value: el.id,
    label: el.shift_time,
  }));
  const shiftEndOptions = shiftEndTime.map(el => ({
    value: el.id,
    label: el.shift_time,
  }));
  const locationOptions = location.map(el => ({
    value: el.rec_id,
    label: el.location_name,
  }));
  const seatOptions = SeatList?.map?.(el => ({
    value: el.seat_id,
    label: el.title,
  }));

  // var filterData = tableData;
  const handleSearch = event => {
    var updatedList = departmentList;

    let value = event.target.value;
    setSearchText(value);
    updatedList = updatedList.filter(function (item) {
      var locationArray = item.locationArr;
      var spocNameArray = item.userArr;
      if (
        item.dept_name
          .trim()
          .toUpperCase()
          .search(value.trim().toUpperCase()) != -1 ||
        isLocationFound(locationArray, value) != undefined ||
        isSpocsName(spocNameArray, value) != undefined
      ) {
        return item;
      }
    });
    setItems(updatedList);
  };

  function isLocationFound(arr, searchString) {
    let obj = arr.find(o => {
      return o.location_name
        .trim()
        .toUpperCase()
        .includes(searchString.trim().toUpperCase());
    });
    return obj;
  }

  function btnClick() {
    mixpanel.track("Department Management Page View", { PageName: 'Department', UserEmail: UserObj.email, UserName: UserObj.fname + " " + UserObj.lname, UserId: UserObj.rec_id, CompanyId: UserObj.company_id, CompanyName: UserObj.company_name, Type: "Department" })
  }

  function isSpocsName(arrays, searchSpocString) {
    let objects = arrays.find(o => {
      return (
        (
          o.fname.trim().toUpperCase() +
          ' ' +
          o.lname.trim().toUpperCase()
        ).includes(searchSpocString.trim().toUpperCase()) ||
        (
          o.fname.trim().toUpperCase() +
          '' +
          o.lname.trim().toUpperCase()
        ).includes(searchSpocString.trim().toUpperCase())
      );
    });
    return objects;
  }

  function onNameChange(event) {
    setDepartmentName(event.target.value);
  }
  function onSpocChange(value) {
    setSelectedSpoc(value);
  }
  function onStartTimeChange(value) {
    if (selectedDepartment.id) {
      setSelectedStartTime(value);
    } else {
      setSelectedStartTime(value);
    }
  }
  function onEndTimeChange(value) {
    if (selectedDepartment.id) {
      setSelectedEndTime(value);
    } else setSelectedEndTime(value);
  }
  function onLocationChange(value) {
    setSeatsNumber([]);
    setSelectedLocation(value);
    var loactaionId = [];
    value.map(location => loactaionId.push(location.value));
    const params = {
      company_id: UserObj.company_id,
      location_id: loactaionId,
    };
    SeatListingDataBasedOnLocation(params);
  }

  function onSeatChange(value) {
    setSeatsNumber(value);
  }

  function resetValue() {
    setDepartmentName('');
    setSelectedSpoc([]);
    setSelectedStartTime([]);
    setSelectedEndTime([]);
    setSelectedLocation([]);
    setSeatsNumber([]);
    setSelectedDepartment([]);
  }

  function submitDepartment() {
    let authToken = JSON.parse(localStorage.getItem('headData'))
    const params = {
      deptId: selectedDepartment.id,
      location: selectedLocation.map(location => ({
        location_id: location.value,
        location_name: location.label,
      })),

    }
    axios
      .post(
        `${process.env.REACT_APP_API_URL}department/get-userCount-by-dept`,
        params, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      }
      )
      .then(res => {
        if (res.data.data.length > 0) {
          setDeletedLocation(res.data);
        }
      });
  }

  function onFormSubmit(e) {
    e.preventDefault();
    if (
      departmentName != '' ||
      selectedSpoc.length > 0 ||
      selectedStartTime.length > 0 ||
      selectedEndTime.length > 0 ||
      selectedLocation.length > 0
    ) {
      if (selectedDepartment.id) {
        const startTime = selectedStartTime.map(time => ({
          id: time.value,
          shift_time: time.label,
          shift_type: 'start_time',
        }));
        const endTime = selectedEndTime.map(time => ({
          id: time.value,
          shift_time: time.label,
          shift_type: 'end_time',
        }));

        const userArray = arrayOfObjectIntersection(
          selectedSpoc.map(el => ({ rec_id: el.value })),
          spoc,
          'rec_id',
        );

        const params = {
          id: selectedDepartment.id,
          company_id: UserObj.company_id,
          dept_name: departmentName,
          userArr: userArray.map(spoc => ({
            id: spoc.rec_id,
            dept_id: spoc.user_dept_id,
            user_id: spoc.rec_id,
            fname: spoc.fname,
            lname: spoc.fname,
          })),
          location: selectedLocation.map(location => ({
            location_id: location.value,
            location_name: location.label,
          })),
          seatIds: seatsNumber.map(seat => ({
            seat_id: seat.value,
            seat_name: seat.title,
          })),
          shiftArr: [...startTime, ...endTime],
        };
        let loc = [];
        params.location.map(e => {
          loc.push(e.location_id);
        })

        const comapany = {
          UserObj: UserObj.company_id,
          LocationObj: loc,
          pgno: 1,
          row: 25,
        }
        updateDepartment(params, comapany);
      } else {
        const params = {
          company: UserObj.company_id,
          departmentName,
          spoc: selectedSpoc.map(spoc => spoc.value),
          location: selectedLocation.map(location => location.value),
          seatIds: seatsNumber.map(seats => seats.value),
          startTime: selectedStartTime.map(startTime => startTime.value),
          endTime: selectedEndTime.map(EndTime => EndTime.value),
          UserObj: UserObj.company_id,
          LocationObj: LocationObj,
          pgno: 1,
          row: 25,
        };

        createDepartment(params);
      }
      setShowConfirmBooking(false);
      setShowDeptCanvas(false);
      resetValue();
    } else {
      toast.error(`Fields Can't Be Empty`, {
      });
    }
    resetValue();
    mixpanel.track("Department Management Add new Success", { PageName: 'Department', UserEmail: UserObj.email, UserName: UserObj.fname + " " + UserObj.lname, UserId: UserObj.rec_id, CompanyId: UserObj.company_id, CompanyName: UserObj.company_name, Type: "Department" })

  }

  function setValueToModal(department) {
    setSelectedDepartment(department);
    setDepartmentName(department.dept_name);

    setSelectedSpoc(
      department.userArr.map(user => ({
        label: `${user.lname} ${user.fname}`,
        value: user.user_id,
      }))
    );

    setSelectedLocation(
      department.locationArr.map(location => ({
        label: location.location_name,
        value: location.location_id,
      }))
    );
    var loactaionTemp = [];
    department.locationArr.map(location => loactaionTemp.push(location.location_id));
    const params1 = {
      company_id: UserObj.company_id,
      location_id: loactaionTemp,
    };
    SeatListingDataBasedOnLocation(params1);

    // setSeatsNumber(
    //   department.seatArr.map(seat => ({
    //     label: seat.title,
    //     value: seat.seat_id,
    //   })),
    // );

    var loactaionId = [];
    department.locationArr.map(location =>
      loactaionId.push(location.location_id),
    );
    const params = {
      company_id: UserObj.company_id,
      location_id: loactaionId,
    };
    let authToken = JSON.parse(localStorage.getItem('headData'))
    SeatListingDataBasedOnLocation(params);
    axios
      .get(`${getDepartmentMasterList}/${UserObj.company_id}/${department.id}/[${LocationObj}]?pgno=${pgno}&row=${row}`, {
        headers: {
          Authorization: authToken?.spintlyToken,
        }
      })
      .then(res => {
        if (res.status === 200) {
          var selecctedSeats = res.data.seatDept;
          setSeatsNumber(
            res.data.seatDept.map(seat => ({
              label: seat.title,
              value: seat.seat_id,
            })),
          );
        }
      })
      .catch(error => { });
    setSelectedStartTime(
      department.shiftArr
        .filter(el => el.shift_type === 'start_time')
        .map(shift => ({ label: shift.time, value: shift.id }))
    );

    setSelectedEndTime(
      department.shiftArr
        .filter(el => el.shift_type === 'end_time')
        .map(shift => ({ label: shift.time, value: shift.id }))
    );


    // ✅ FIX FOR SEAT NUMBER
    setSeatsNumber(
      department.seatArr.map(seat => ({
        label: seat.title,     // MUST MATCH seatOptions.label
        value: seat.seat_id,   // MUST MATCH seatOptions.value
      }))
    );

    setShowDeptCanvas(true); // ✅ OPEN OFFCANVAS
  }

  function addDeptMixPanel() {
    mixpanel.track("Department Management Add new", { PageName: 'Department', UserEmail: UserObj.email, UserName: UserObj.fname + " " + UserObj.lname, UserId: UserObj.rec_id, CompanyId: UserObj.company_id, CompanyName: UserObj.company_name, Type: "Department" })
  }

  function exportMixPanel() {
    mixpanel.track("Department Management Export", { PageName: 'Department', UserEmail: UserObj.email, UserName: UserObj.fname + " " + UserObj.lname, UserId: UserObj.rec_id, CompanyId: UserObj.company_id, CompanyName: UserObj.company_name, Type: "Department" })
  }

  const TableHeader = [
    { key: 'createdat', text: 'Date Added' },
    { key: 'dept_name', text: 'Department Name' },
    { key: 'userArr', text: 'Spoc' },
    { key: 'locationArr', text: 'Locations' },
    { key: 'shiftArr', text: 'Shift Login Times' },
    { key: 'shiftArr', text: 'Shift Logout Times' },
  ];

  const CsvHeader = [
    { key: 'createdat', label: 'Date Added' },
    { key: 'dept_name', label: 'Department Name' },
    { key: 'userArr', label: 'Spoc' },
    { key: 'locationArr', label: 'Locations' },
    { key: 'seatArr', label: 'Seats' },
    { key: 'shiftStartTime', label: 'Shift Login Times' },
    { key: 'shiftEndTime', label: 'Shift Logout Times' },
  ];


  let serviceAccess = true;
  const serviceAccessId = 14;
  if (accessServiceLists.length > 0) {
    let serviceAccessobject = {};
    accessServiceLists.map(e => {
      if (e.id == serviceAccessId) serviceAccessobject = e;
    });
    serviceAccess = false;
    if (serviceAccessobject)
      serviceAccess = serviceAccessobject.service_access;
  }

  function cancelEvent() {
    setDeletedLocation([]);
    setShowConfirmBooking(false); // ✅ CLOSE MODAL

  }

  const selectRows = e => {
    setRow(Number(e.target.value))
    const param = {
      UserObj: UserObj.company_id,
      LocationObj: LocationObj,
      pgno: 1,
      row: Number(e.target.value),
    }
    getDepartmentList(param);

  };

  const pageBackword = () => {
    setPgno(pgno - 1)
    const param = {
      UserObj: UserObj.company_id,
      LocationObj: LocationObj,
      pgno: pgno - 1,
      row: row,
    }
    getDepartmentList(param);
  }

  const forwordPage = () => {
    setPgno(pgno + 1)
    const param = {
      UserObj: UserObj.company_id,
      LocationObj: LocationObj,
      pgno: pgno + 1,
      row: row,
    }
    getDepartmentList(param);
  }


  const columns = [
    {
      title: "Date Added",
      minWidth: 150,
      dataIndex: "createdat",
      key: "createdat",
      render: (value) =>
        value ? moment(value).format("ddd, D MMM, YYYY") : "--",
    },
    {
      title: "Department Name",
      dataIndex: "dept_name",
      key: "dept_name",
      // noWrap: true,
      minWidth:150,
    },
    {
      title: "Spoc",
      key: "userArr",
      minWidth: 150,
      render: (_, record) =>
        record.userArr?.map(u => `${u.fname} ${u.lname}`).join(", "),
    },
    {
      title: "Locations",
      key: "locationArr",
      minWidth: 200,
      render: (_, record) =>
        record.locationArr?.map(l => l.location_name).join(", "),
    },
    {
      title: "Shift Login Times",
      minWidth: 150,
      render: (_, record) =>
        record.shiftArr
          ?.filter(s => s.shift_type === "start_time")
          .map(s => s.time)
          .join(", "),
    },
    {
      title: "Shift Logout Times",
      minWidth: 250,
      key: "shiftEnd",
      render: (_, record) =>
        record.shiftArr
          ?.filter(s => s.shift_type === "end_time")
          .map(s => s.time)
          .join(", "),
    },

    /* ✅ ACTION COLUMN */
    {
      title: "Update",
      key: "action",
      noWrap: true,
      align: "center",
      render: (_, record) =>
        isEditable ? (
          <a className="SwLinkSecondary" type='button' onClick={() => setValueToModal(record)}>
            <i class="bi bi-pencil-square"></i>
          </a>

        ) : (
          "--"
        ),
    },
  ];


  return (
    <>


      <Layout>
        <Sidebar collapsed={collapsed} />
        <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} activePg={pgno} activeRow={row} />


        <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
          {(serviceAccess === true && loaderServiceAccess == false) ?
            <>
              <>


                <SwOffCanvas
                  show={showDeptCanvas}
                  onClose={() => {
                    setShowDeptCanvas(false);
                    resetValue();
                  }}
                  title={
                    selectedDepartment.id
                      ? 'Update Department / Zone'
                      : 'Add New Department / Zone'
                  }
                  placement="end"
                  backdrop="static"
                  keyboard={false}
                  footer={
                     <div className="d-flex justify-content-end align-items-center gap-3">
                      <SwButton
                        variant="dark-outline"
                        onClick={resetValue}
                      >
                        Reset
                      </SwButton>

                      <SwButton
                        variant="primary"
                        className="ml10"
                        onClick={handleOpenBookingModal}
                      >
                        {selectedDepartment.id ? 'Update' : 'Submit'} Department / Zone
                      </SwButton>
                    </div>
                  }
                >
                  {/* ===== FORM CONTENT ===== */}
                  <div className="row">
                    <div className="col-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Department Name <span className='Required'>*</span>
                        </label>
                        <SwInput
                          maxLength="50"
                          value={departmentName}
                          onChange={onNameChange}
                          placeholder='Enter Department Name'
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Shift Login <span className='Required'>*</span>
                        </label>
                        <SwMultiSelect
                          options={shiftStartOptions}
                          value={selectedStartTime}
                          onChange={onStartTimeChange}
                          placeholder="Select Shift Login"
                          labelledBy="Shift Login"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Shift Logout <span className='Required'>*</span>
                        </label>
                        <SwMultiSelect
                          options={shiftEndOptions}
                          value={selectedEndTime}
                          onChange={onEndTimeChange}
                          placeholder="Select Shift Logout"
                          labelledBy="Shift Logout"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">
                          Location <span className='Required'>*</span>
                        </label>
                        <SwMultiSelect
                          options={LocationData}
                          value={selectedLocation}
                          onChange={onLocationChange}
                          placeholder="Select Location"
                          labelledBy="Location"
                        />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="SwFormGroup">
                        <label className="SwFormLabel">Seat Number</label>
                        <SwMultiSelect
                          options={seatOptions}
                          value={seatsNumber}
                          onChange={onSeatChange}
                          placeholder="Select Seat Number"
                          labelledBy="Seat Number"
                        />
                      </div>
                    </div>
                  </div>
                </SwOffCanvas>




                <SwModal
                  show={showConfirmBooking}
                  onClose={handleCloseBooking}
                  // title="Alert !!"
                  size="sm"
                  className="sw-small-modal"
                  footer={
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <SwButton
                        variant="dark-outline"
                        onClick={cancelEvent}
                        size="sm"
                      >
                        Cancel
                      </SwButton>

                      <SwButton
                        variant="primary"
                        size="sm"
                        onClick={onFormSubmit}
                      >
                        Confirm
                      </SwButton>
                    </div>
                  }
                >
                  <SwButton variant="" className='btn-close btn-close-custom' onClick={cancelEvent} ></SwButton>
                  <h3 className="SwModalSubHeading text-center">
                    {delLocations.userCount > 0 ? (
                      <>
                        This department is already assigned to{" "}
                        <strong>{delLocations.userCount}</strong> Employees at{" "}
                        <strong>{delLocations.userLocations}</strong>.
                        When you update this department, employees will be unassigned.
                        <br />
                        <strong>Are you sure you want to update the department data?</strong>
                      </>
                    ) : (
                      "Are you sure you want to update the department data?"
                    )}
                  </h3>
                </SwModal>


                <div className="PageContent">
                  <div className="row">
                    <div className="col-md-6 col-xl-6 col-lg-6 col-xs-12">
                      <div className='SwHeading'>
                        <h2>Department Master</h2>
                      </div>
                      
                      <div className='SwSubHeading Hv2'>
                        <h4>All Department / Zone</h4>
                      </div>

                    </div>
                    <div className="col-md-6 ">
                      <div className="PageHead_Optons_Row">
                        <ul className='PageHead_Optons_RightAligned'>
                          
                          <li>
                            <div className="SwInputWithIcon">
                              <SwInput type="text" placeholder="Search..." onChange={event => handleSearch(event)} />
                              <span className="SwInputicon">
                                <i className="bi bi-search"></i>
                              </span>
                            </div>
                          </li>
                          {isEditable && (
                            <li>
                              <SwButton
                                variant='primary'
                                icon={<i class="bi bi-plus-circle"></i>}
                                iconPosition='start'
                                size="sm"
                                onClick={() => {
                                  resetValue();              // clear form
                                  setSelectedDepartment({}); // ADD MODE
                                  setShowDeptCanvas(true);   // ✅ OPEN OFFCANVAS
                                  addDeptMixPanel();
                                }}
                              >
                                Add New Department/Zone
                              </SwButton>

                            </li>
                          )}
                          <li>
                            {console.log(departmentList, items, "departmentList")}
                            {items.length > 0 ?
                              <CSVLink
                                data={csvData}
                                headers={CsvHeader}
                                filename={'department.csv'}
                              >
                                <SwButton
                                  onClick={exportMixPanel}
                                  variant="dark"
                                  icon={<i class="bi bi-box-arrow-right"></i>}
                                  iconPosition='start'
                                  size="sm"
                                >
                                  Export
                                </SwButton>
                              </CSVLink> :
                              <SwButton variant="dark" disabled size="sm" loading >
                                Loading Export
                              </SwButton>}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="">
                        <div
                          className={loader == true ? 'loader disable' : 'loader'}
                        />
                        <div className="">
                          <AntDTable
                            columns={columns}
                            dataSource={items}
                            rowKey="id"
                            loading={departmentListLoading}
                            pagination={items.length > 0}   // ✅ KEY LINE
                            pageSize={row}
                            currentPage={pgno}
                            totalRecords={total}
                            size="small"
                            onPageChange={(page, pageSize) => {
                              setPgno(page);
                              setRow(pageSize);

                              getDepartmentList({
                                UserObj: UserObj.company_id,
                                LocationObj: LocationObj,
                                pgno: page,
                                row: pageSize,
                              });
                            }}
                          />


                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </>

            </>
            : loaderServiceAccess == true ? (

              <>

                <SwLoader />
              </>

            ) : <MarketingPanel />

          }
        </Layout>
      </Layout>
    </>
  );
}

// const mapStateToProps = state => ({
//   departmentData: state.departmentData,
// });
const mapStateToProps = state => {
  return {
    departmentData: state.departmentData,
    seatList: state.seatReducer,
  };
};
const mapActionsToProps = {
  getDepartmentOptions,
  createDepartment,
  getDepartmentList,
  updateDepartment,
  SeatListingDataBasedOnLocation,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(Department);
